import {
    Box,
    Button,
    Paper,
    Stack,
    Typography,
    useMediaQuery,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import ExperiencesListOwnerComponent from '../../../components/Experiences/Owner/ExperiencesListOwnerComponent';
import OwnerListingsHero, {
    type OwnerListingStatusFilter,
} from '../../../components/Experiences/Owner/OwnerListingsHero';
import { AddCircle } from '@mui/icons-material';
import ListingModal from '../../../components/Experiences/Owner/ListingModal';

export default function ViewOwnersExperiencesPage() {
    const isMobile = useMediaQuery('(max-width: 900px)');
    const isDesktop = useMediaQuery('(min-width: 901px)');
    const urlRef = window.location.href.split('/')[4];
    const [statusFilter, setStatusFilter] =
        useState<OwnerListingStatusFilter>('all');
    const [locationFilter, setLocationFilter] = useState('all');
    const [experiences, setExperiences] = useState<any[]>([]);
    const [modalOpen, setModalOpen] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const visitType =
        urlRef === 'business'
            ? 'business'
            : urlRef === 'personal'
              ? 'personal'
              : undefined;

    return (
        <>
            <Stack
                spacing={2}
                sx={{
                    width: '100%',
                    ...(isDesktop && {
                        height: 'calc(100vh - 130px - var(--app-prompt-banner-height, 0px))',
                        maxHeight:
                            'calc(100vh - 130px - var(--app-prompt-banner-height, 0px))',
                        overflow: 'hidden',
                    }),
                }}
            >
                <Box sx={{ width: '100%', flexShrink: 0 }}>
                    <Typography
                        component='h1'
                        variant='h1'
                        sx={{
                            textAlign: 'left',
                            textTransform: 'none',
                            mb: 0.5,
                        }}
                    >
                        My Listings
                    </Typography>
                    <Typography variant='body1' color='text.secondary'>
                        Manage your listings, availability and details
                    </Typography>
                </Box>

                <Paper
                    variant='outlined'
                    sx={{
                        width: '100%',
                        borderRadius: 2,
                        borderColor: 'divider',
                        overflow: 'hidden',
                        flexShrink: 0,
                    }}
                >
                    <Box
                        sx={{ px: { xs: 1.5, sm: 2 }, py: { xs: 1.25, sm: 1 } }}
                    >
                        <OwnerListingsHero
                            experiences={experiences}
                            statusFilter={statusFilter}
                            onStatusFilterChange={setStatusFilter}
                            locationFilter={locationFilter}
                            onLocationFilterChange={setLocationFilter}
                        />
                    </Box>
                </Paper>
                <Box sx={{ ml: 'auto' }}>
                    <Button
                        variant='contained'
                        onClick={() => setModalOpen(true)}
                        startIcon={<AddCircle />}
                    >
                        {' '}
                        New Listing
                    </Button>
                </Box>
                <Paper
                    variant='outlined'
                    sx={{
                        width: '100%',
                        borderRadius: 2,
                        borderColor: 'divider',
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: 'column',
                        flex: isDesktop ? 1 : undefined,
                        minHeight: isDesktop ? 0 : undefined,
                    }}
                >
                    <Box
                        sx={{
                            p: { xs: 0, sm: 0.5 },
                            overflowX: 'auto',
                            overflowY: isDesktop ? 'hidden' : undefined,
                            pb: isMobile ? 4 : 0,
                            flex: isDesktop ? 1 : undefined,
                            minHeight: isDesktop ? 0 : undefined,
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <Typography component='h2' variant='visuallyHidden'>
                            Experiences
                        </Typography>
                        <ExperiencesListOwnerComponent
                            visitType={visitType}
                            statusFilter={statusFilter}
                            locationFilter={locationFilter}
                            onExperiencesLoaded={setExperiences}
                        />
                    </Box>
                </Paper>
            </Stack>
            <ListingModal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
            />
        </>
    );
}
